import {ITheme} from 'contexts/ThemeContext';
import {Platform, useWindowDimensions} from 'react-native';
import strings from 'translations/index.web';

export default ({colors, typography}: ITheme) => {
  const {width, height} = useWindowDimensions();

  return {
    defaultStyle: {},
    defaultChartValueStyle: {
      position: 'absolute',
      bottom: 26,
      height: 166,
    },
    defaultChartValueStyleWeb: (chartType: string) => ({
      position: 'absolute',
      bottom: chartType === strings.analyticsScreen.speakers ? 21 : 10,
    }),
    speakerBarStyle: (
      domain: number,
      propsStartOffset: number,
      basicStartOffset: number,
      propsEndOffset: number,
    ) => ({
      left: domain * propsStartOffset - basicStartOffset,
      alignItems: 'center',
      width: (propsEndOffset - propsStartOffset) * domain,
      borderStyle: 'dashed',
      borderWidth: Platform.OS === 'web' ? 0 : 1,
      borderColor: colors.heliotrope,
    }),
    beforeViewStyle: {
      marginTop: -5,
      width: '100%',
      height: Platform.OS === 'web' ? 6 : 11,
      borderRadius: 6,
      backgroundColor: colors.heliotrope,
    },
    gradientBarStyle: {
      height: '100%',
      width: '100%',
    },
    reactionBarStyle: (
      domain: number,
      propsStartOffset: number,
      basicStartOffset: number,
    ) => ({
      left:
        Platform.OS === 'web'
          ? domain * propsStartOffset - basicStartOffset - 15
          : domain * propsStartOffset - basicStartOffset,
    }),
    reactionSize: {
      fontSize: 28,
    },
  };
};
